import { render, staticRenderFns } from "./asset-manage.vue?vue&type=template&id=1fadc21c&scoped=true&"
import script from "./asset-manage.vue?vue&type=script&lang=js&"
export * from "./asset-manage.vue?vue&type=script&lang=js&"
import style0 from "./asset-manage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./asset-manage.vue?vue&type=style&index=1&id=1fadc21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fadc21c",
  null
  
)

export default component.exports